export {};

$(init);

NLMK.initSvgMap = init;

function init() {
    const $mapSections = $('.map-section');

    if ($mapSections.length > 0 && $mapSections.data('autoinit')) {
        require.ensure(
            ['./module'],
            () => {
                const { initMap } = require('./module');

                initMap($mapSections);
            },
            'map',
        );
    }

}



// WEBPACK FOOTER //
// ./js/main/module/map/index.js